"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalSheetManagementHeader = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var react_intl_1 = require("react-intl");
var styles_1 = require("@material-ui/core/styles");
var classnames_1 = __importDefault(require("classnames"));
var useResetStyles_1 = require("../../../hooks/useResetStyles");
var components_1 = require("../../../components");
var hooks_1 = require("../../../hooks");
var ApprovalSheetCollisionPopover_1 = require("./ApprovalSheetCollisionPopover");
var utils_1 = require("../../../utils");
var context_1 = require("../../../context");
var useApprovalSheetManagementHeaderStyles = styles_1.makeStyles(function (theme) {
    var _a = theme.variables.palette.approval, borderBase = _a.borderBase, borderRadiusBase = _a.borderRadiusBase, management = _a.management;
    return {
        root: {
            padding: "8px " + management.paddingHorizontal,
            border: borderBase,
            borderBottom: 'none',
            borderRadius: borderRadiusBase + " " + borderRadiusBase + " 0px 0px",
        },
        title: {
            fontWeight: 600,
            fontSize: '16px',
        },
    };
});
exports.ApprovalSheetManagementHeader = function (props) {
    var templateName = props.templateName;
    var sheet = react_1.useContext(context_1.ApprovalSheetContext).sheet;
    var statusType = sheet.statusType;
    var isCollisionSheetStatus = statusType ? utils_1.isCollisionStatus(statusType) : false;
    var theme = core_1.useTheme();
    var classes = useApprovalSheetManagementHeaderStyles();
    var resetClasses = useResetStyles_1.useResetStyles();
    var headerClasses = hooks_1.useHeaderStyles();
    return (react_1.default.createElement(core_1.Box, { className: classes.root },
        react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justify: "space-between", alignItems: "baseline", wrap: "nowrap", component: "dl", className: resetClasses.resetCss },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Grid, { container: true, direction: "row", spacing: 3, alignItems: "center" },
                    react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(core_1.Typography, { component: "h3", className: classes.title },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "approvalSheetManagement" }))),
                    isCollisionSheetStatus && (react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(ApprovalSheetCollisionPopover_1.ApprovalSheetCollisionPopover, null))))),
            templateName && (react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Grid, { container: true, alignItems: "baseline", spacing: 2, wrap: "nowrap" },
                    react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(core_1.Box, { color: theme === null || theme === void 0 ? void 0 : theme.palette.primary.light },
                            react_1.default.createElement(core_1.Typography, { variant: "body1", component: "dt", className: resetClasses.resetCss },
                                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "templateLabel" })))),
                    react_1.default.createElement(core_1.Grid, { item: true },
                        react_1.default.createElement(core_1.Typography, { variant: "body2", component: "dd", noWrap: true, className: classnames_1.default(headerClasses.headerValue, resetClasses.resetCss) },
                            react_1.default.createElement(components_1.EllipsisBox, { text: templateName, correctLength: 40 })))))))));
};
